import React, {FC} from 'react';
import Modal from '@mui/material/Modal';
import styles from './SimpleModal.module.scss'
import clsx from "clsx";

interface SimpleModalProps {
    isOpen: boolean
    onClose?: () => void
    children: React.ReactNode
    className?: string
}

export const SimpleModal:FC<SimpleModalProps> = ({ isOpen, onClose, children, className }) => {
    return (
        <Modal
            className={clsx(styles.modal, className)}
            open={isOpen}
            onClose={onClose}
        >
            <div className={styles.window}>
                {children}
            </div>
        </Modal>
    );
}
